import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import type { LangKey } from "@sveabank/cc-common";

export type SveaError = {
	errorMsg?: string;
	statusCode?: number | null;
	errorCode?: string | null;
	stack?: string;
	correlationId?: string;
};

export type ApiError = {
	data: {
		context: unknown;
		description: string | null;
		errorCode: string | null;
	};
	status: number;
};

export const isApiError = (e: unknown): e is ApiError => {
	if (
		e &&
		typeof e === "object" &&
		"data" in e &&
		"status" in e &&
		typeof e.data === "object" &&
		e.data !== null
	)
		return true;
	return false;
};

export const isFetchBaseQueryError = (e: unknown): e is FetchBaseQueryError => {
	if (e && typeof e === "object" && "status" in e && "error" in e) return true;
	return false;
};

export type ErrorContent = {
	heading: LangKey;
	body: LangKey;
};
